/**
 * Nav Tabs Module
 * Provides tab navigation and button visibility management
 * Dependencies: jQuery, Bootstrap
 */

import { $ } from '../vendor_imports'

/**
 * Updates tab title and manages hash-based navigation
 */
export const navTabsManager = function(appendedTitle) {
  // Skip if we're on a page with V1 navigation tabs
  if ($('.v1-navigation-tabs').length && !$('a[data-toggle="tab"]').length) {
    return
  }

  const updateTitle = ($tab) => {
    if ($tab.data("ignore-manager")) return

    let tabTitle = $tab.text().replace(/\(\d+\)/, '')
    if (appendedTitle) {
      tabTitle = `${tabTitle} ${appendedTitle}`
    }
    $('[data-tabs-title]').text(tabTitle)
  }

  const showTabFromHash = () => {
    if (location.hash) {
      try {
        const hashValue = location.hash.replace('tab_', '')
        // Escape special characters for jQuery selector
        const escapedHash = hashValue.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&")
        const $tabLink = $(`a[href="${escapedHash}"]`).not('.v1-navigation-tabs a')
        if ($tabLink.length) {
          $tabLink.tab('show')
          updateTitle($tabLink)
        }
      } catch (e) {
        console.error('Error showing tab from hash:', e)
        const $firstTab = $('.nav-tabs a:first').not('.v1-navigation-tabs a')
        if ($firstTab.length) {
          $firstTab.tab('show')
          updateTitle($firstTab)
        }
      }
    } else {
      const $firstTab = $('.nav-tabs a:first').not('.v1-navigation-tabs a')
      if ($firstTab.length) {
        $firstTab.tab('show')
        updateTitle($firstTab)
      }
    }
  }

  // Initialize tabs from URL hash
  showTabFromHash()

  // Handle tab changes (skip V1 navigation tabs)
  $('a[data-toggle="tab"]').not('.v1-navigation-tabs a').on('shown', function(e) {
    updateTitle($(this))
    location.hash = `tab_${e.target.hash.substr(1)}`
    return false
  })
}

/**
 * Manages button visibility based on active tab
 */
export const navTabsButtonManager = function() {
  const showButtonsForTab = ($tab) => {
    $('[data-button]').hide()
    const buttonShow = $tab.data('button-show')
    if (buttonShow) {
      $(`[data-button=${buttonShow}]`).show()
    }
  }

  // Initialize buttons from URL hash
  if (location.hash) {
    try {
      const hashValue = location.hash.replace('tab_', '')
      // Escape special characters for jQuery selector
      const escapedHash = hashValue.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&")
      const $tabLink = $(`a[href="${escapedHash}"]`)
      if ($tabLink.length) {
        showButtonsForTab($tabLink)
      } else {
        $('[data-button-default]').show()
      }
    } catch (e) {
      console.error('Error showing buttons from hash:', e)
      $('[data-button-default]').show()
    }
  } else {
    $('[data-button-default]').show()
  }

  // Handle tab changes (skip V1 navigation tabs)
  $('a[data-toggle="tab"]').not('.v1-navigation-tabs a').on('shown', function(e) {
    showButtonsForTab($(this))
    return false
  })
}
